import React from 'react';

import fetch from '../fetch';

import moment from 'moment';

import utils from '../../utils';

import {Modal, message, Tag} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {
        key:'$index', 
        label: '序号'
    },
    {
        key:'targetName', 
        label: '指标', 
        width: 100
    },
    {
        key: 'status',
        label: '状态',
        width: 120,
        render: (value) => {
            if(value === 1 || value === 0) {
                return <Tag color="#2db7f5">未提交</Tag>
            } else if(value === 2) {
                return <Tag color="#87d068">已提交</Tag>
            } else {
                return <Tag>未知</Tag>
            }
        }
    },
    {
        key: 'goalPercentage', 
        label: '完成率', 
        width: 100
    },
    {
        key: 'employeeCode', 
        label: '职工号', 
        width: 100
    },
    {
        key: 'name', 
        label: '姓名',
        width: 120
    },
    {
        key: 'orgName', 
        label: '所属部门',
        width: 150
    },
    {
        key: 'termName', 
        label: '学期', 
        width: 160
    },
]);


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('develop/teacher/result/query?' + params.join('&'), keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const queryDetail = (id) => {
    return fetch.get(`develop/teacher/result/detail/${id}`);
}


/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection =() => {
    return DataGrid.selections;
}

const getStatusById = (id) => {
    return fetch.get(`develop/teacher/result/status/${id}`)
}

const back = (ids) => {
    return fetch.post(`develop/teacher/result/status/back`, ids);
}

const update = (id, data) => {
    return fetch.post(`develop/teacher/result/update/${id}`, data);
}

export default {
    querySearch,
    columns,
    onSelect,
    setRefresh,
    getSelection,
    getStatusById,
    queryDetail,
    back,
    update
}